import React, { useMemo } from 'react';

const EmbedRutube = ({link, iframeRef}) => {
    const emdedLink = useMemo(() => {
        if (link.includes('rutube.ru/play/embed')) {
            return link;
        }

        // const linkId = link.https://rutube.ru/video/f765cedc1a74795c89a39d4619f1b9d2/?asdasd(/(?<=video\/).*?(?=\/)/g)[0];
        const linkId = link?.split('?')?.[0].split('/').filter((s) => !!s).splice(-1, 1)?.[0] ?? '';
        
        return linkId ? `https://rutube.ru/play/embed/${linkId}` : null;
    }, [link]);
    
    if (!emdedLink) {
        return (<></>)
    }

    return (
        <iframe
            ref={iframeRef}
            width="900"
            height="532"
            src={emdedLink}
            frameBorder="0"
            allow="clipboard-write; autoplay"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen
        />
    )
};

export default EmbedRutube;
